import "./styles.scss";

import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import LanguageDetector from "i18next-browser-languagedetector";

import Pagination from "../../components/Pagination";
import Filter from "../../components/elements/Filter";
import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import CardList from "../../components/elements/CardList";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import { getFilterTickets, getSubTypeID } from "../../store/middleware";
import { setCleanTicket } from "../../store/slices/customerService.slice";
import { getTicketMessages } from "../../store/middleware/customerService.middleware";
import CustomerService from "../../assets/images/icons/icon_customerservice_header.svg";

function CostumerService() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const currentLanguage = i18next.use(LanguageDetector);

  const { user } = useSelector((state) => state.userReducer);
  const { tickets, ticketsInfo } = useSelector((state) => state.customerServiceReducer);

  const [filters, setFilters] = useState({
    id: "",
    status: "",
    pageSize: 10,
    createdAt: "",
    requester: "",
    pageNumber: 1,
    ticketTypeId: "",
    ticketSubTypeId: "",
    role: user?.role === "affiliate" ? "affiliate" : "",
    creatorUserId: user?.role === "affiliate" ? user?.id : "",
  });

  const handlePagination = (page) => {
    filters["pageNumber"] = Number(page);
    setFilters(filters);
    handleApplyFilters();
  };

  const inputChange = useCallback((e, name) => {
    const { value } = e.target;

    setFilters((state) => ({ ...state, [name]: value }));
    name === "ticketTypeId" && value !== "" && dispatch(getSubTypeID(value));

    // eslint-disable-next-line
  }, []);

  const handleApplyFilters = () => dispatch(getFilterTickets(filters, "list"));

  const handleResetFilter = async () => {
    const payload = {
      id: "",
      requester: "",
      role: user?.role === "affiliate" ? "affiliate" : "",
      creatorUserId: user?.role === "affiliate" ? user?.id : "",
      ticketTypeId: "",
      ticketSubTypeId: "",
      createdAt: "",
      status: "",
      pageNumber: 1,
      pageSize: 10,
    };

    await dispatch(getFilterTickets(payload));
    dispatch(setCleanTicket());
    setFilters(payload);
  };

  useEffect(() => {
    handleResetFilter();
    // eslint-disable-next-line
  }, []);

  const newfilters =
    user?.role === "student" || user?.role === "teacher" || user?.role === "affiliate"
      ? [
          { name: "id", value: filters.id, label: "TICKET_ID", placeholder: "ENTER_TICKET", type: "text" },
          { name: "ticketTypeId", value: filters.ticketTypeId, type: "ticketTypes" },
          { name: "ticketSubTypeId", value: filters.ticketSubTypeId, type: "ticketSubTypes" },
          { name: "createdAt", value: filters.createdAt, label: "OPEN_DATE", type: "date" },
          { name: "status", value: filters.status, type: "ticketStatus" },
        ]
      : [
          { name: "id", value: filters.id, label: "TICKET_ID", placeholder: "ENTER_TICKET", type: "text" },
          {
            name: "requester",
            value: filters.requester,
            label: t("CREATOR_USER_ID"),
            placeholder: "ENTER_NAME",
            type: "text",
          },
          { name: "role", value: filters.role, type: "ticketProfiles" },
          { name: "ticketTypeId", value: filters.ticketTypeId, type: "ticketTypes" },
          { name: "ticketSubTypeId", value: filters.ticketSubTypeId, type: "ticketSubTypes" },
          { name: "createdAt", value: filters.createdAt, label: "OPEN_DATE", type: "date" },
          { name: "status", value: filters.status, type: "ticketStatus" },
        ];

  const listedTickets =
    tickets.length > 0
      ? tickets.map((item) => {
          let ticketType = "";
          let ticketSubType = "";

          if (currentLanguage.language === "en") {
            ticketType = item?.ticketType?.nameEnglish;
            ticketSubType = item?.ticketSubType?.nameEnglish;
          }
          if (currentLanguage.language === "pt") {
            ticketType = item?.ticketType?.namePortuguese;
            ticketSubType = item?.ticketSubType?.namePortuguese;
          }
          if (currentLanguage.language === "es") {
            ticketType = item?.ticketType?.nameSpanish;
            ticketSubType = item?.ticketSubType?.nameSpanish;
          }

          return {
            id: item.id,
            status: item.status,
            title: item.title,
            creatorUserId: decryptIfEncrypted(item.creatorUser.name),
            role: item.creatorUser?.role,
            type: ticketType,
            subType: ticketSubType,
            createdAt: item.createdAt,
            lastInteraction: item.updatedAt,
            timezone: user.timezone,
          };
        })
      : [];

  const listItems = [
    { label: "Ticket #", name: "id" },
    { label: t("STATUS"), name: "status" },
    { label: t("TITLE"), name: "title" },
    { label: t("CREATOR_USER_ID"), name: "creatorUserId" },
    { label: t("PROFILE"), name: "role" },
    { label: t("TYPE"), name: "type" },
    { label: t("SUBTYPE"), name: "subType" },
    { label: t("OPEN_DATE"), name: "createdAt" },
    { label: t("LAST_INTERACTION"), name: "lastInteraction" },
    { label: "", name: "button" },
  ];

  const handleTitketDetails = useCallback(async (id) => {
    await dispatch(getFilterTickets({ ...filters, id: id }, "details"));
    await dispatch(getTicketMessages(id));

    window.location.href = "/customer-service/ticketDetail";
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <SideMenu lang={"english"} />
      <section>
        <Header
          title={t("CUSTOMER_SERVICE")}
          icon={<img src={CustomerService} alt="Customer Service" />}
          typeIcon="custom"
          rightButton={
            (user?.role === "student" || user?.role === "teacher" || user?.role === "affiliate") && (
              <button className="buttonRight" onClick={() => navigate("/customer-service/new")}>
                <i className="fa fa-plus" aria-hidden="true" />
                {t("ADD_NEW_TICKET")}
              </button>
            )
          }
          t={t}
        />
        <div className="contentCS">
          <Filter
            filters={newfilters}
            inputChange={inputChange}
            clear={handleResetFilter}
            submit={handleApplyFilters}
          />
          <CardList
            component="customer-service"
            listItems={listItems}
            listedItems={listedTickets}
            action={(id) => handleTitketDetails(id)}
          />

          <Pagination
            totalFound={ticketsInfo?.pageSize}
            totalPages={ticketsInfo?.totalPages}
            pageCurrent={ticketsInfo?.pageNumber}
            totalResults={ticketsInfo?.totalFound}
            onClick={(page, type) => handlePagination(page, type)}
          />
        </div>
      </section>
    </div>
  );
}

export default CostumerService;
